import { Controller } from "@hotwired/stimulus"

/**
 * Topic Selector Controller
 *
 * Handles visual selection of topic options for AI recommendations.
 *
 * Usage:
 *   <div data-controller="topic-selector">
 *     <label class="topic-option" data-topic-selector-target="option" data-action="click->topic-selector#select">
 *       <input type="radio" name="type" value="all" data-topic-selector-target="radio">
 *       ...
 *     </label>
 *   </div>
 */
export default class extends Controller {
  static targets = ["option", "radio", "form"]

  connect() {
    // Ensure initial state reflects checked radio
    this.updateSelection()
  }

  select(event) {
    const clickedOption = event.currentTarget
    const radio = clickedOption.querySelector('input[type="radio"]')

    if (radio) {
      radio.checked = true
      this.updateSelection()
    }
  }

  updateSelection() {
    this.optionTargets.forEach(option => {
      const radio = option.querySelector('input[type="radio"]')
      if (radio && radio.checked) {
        option.classList.add('selected')
      } else {
        option.classList.remove('selected')
      }
    })
  }
}
